import React from 'react';
import {OrbitComponent} from '../../../base-components/orbit-component/orbit-component';
import {SearchTitleBox} from "./boxes/search-title-box/search-title.box";
import {CyClass} from '../../../../../common/cy-classes';

export interface SearchBoxTitleComponentProps {
  title: string;
}

export class SearchBoxTitleComponent extends OrbitComponent<SearchBoxTitleComponentProps> {
  render() {
    return (
      <SearchTitleBox className={CyClass('cy-search-title-box')}>
        {this.services.translation.translate(this.props.title)}
      </SearchTitleBox>
    )
  }
}
